// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"CheckBox_checkboxContainer__lCn16"};